/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Polyfill for Element APIs for IE11
 * from https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
const applyPolyfills = function () {
    if (!(Element.prototype as any).matches) {
        Element.prototype.matches =
            (Element.prototype as any).msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
    }

    if (!(Element.prototype as any).closest) {
        Element.prototype.closest = function (s) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            let el = this;

            do {
                if (Element.prototype.matches.call(el, s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }

    function ReplaceWithPolyfill(...args) {
        // "use-strict"; // For safari, and IE > 10
        const parent = this.parentNode;
        let i = args.length,
            currentNode;
        if (!parent) return;
        if (!i)
            // if there are no arguments
            parent.removeChild(this);
        while (i--) {
            // i-- decrements i and returns the value of i before the decrement
            currentNode = args[i];
            if (typeof currentNode !== "object") {
                currentNode = this.ownerDocument.createTextNode(currentNode);
            } else if (currentNode.parentNode) {
                currentNode.parentNode.removeChild(currentNode);
            }
            // the value of "i" below is after the decrement
            if (!i)
                // if currentNode is the first argument (currentNode === arguments[0])
                parent.replaceChild(currentNode, this);
            // if currentNode isn't the first
            else parent.insertBefore(this.previousSibling, currentNode);
        }
    }

    if (!(Element.prototype.replaceWith as any))
        Element.prototype.replaceWith = ReplaceWithPolyfill;
};

export default applyPolyfills;
